module.exports = __webpack_public_path__ + "img/icon-security-2.2f15498d.svg";